module.exports = __webpack_public_path__ + "img/ttlaw_sample.0251b353.png";